// @flow
// Types

// Constants
import { FIELD, PROP_LABEL, PROP_CATEGORY, PROP_PARENT, PROP_SEASON } from 'fc-model-assets'

// Export
export default function validateModel (model: Object): Array<{ [string]: string }> {
  const errors = []

  if (!model[PROP_CATEGORY]) {
    errors.push({ [PROP_CATEGORY]: 'categoryIsRequired' })
  }

  // check type of operation
  if (model[PROP_CATEGORY] === FIELD) {
    if (!`${model[PROP_LABEL]}`.trim()) {
      errors.push({ [PROP_LABEL]: 'fieldLabelRequired' })
    }

    if (!model[PROP_PARENT]) {
      errors.push({ [PROP_PARENT]: 'farmRequired' })
    }

    if (!model[PROP_SEASON]) {
      errors.push({ [PROP_SEASON]: 'seasonRequired' })
    }
  } else {
    if (!`${model[PROP_LABEL]}`.trim()) {
      errors.push({ [PROP_LABEL]: 'labelRequired' })
    }

    if (!model[PROP_PARENT]) {
      errors.push({ [PROP_PARENT]: 'parentRequired' })
    }
  }

  return errors
}
